import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const ModalTitle = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("h1", {
        className: classNames("line-clamp-2 break-words text-24 font-semibold text-grey-12", className),
        "data-testid": "MODAL_TITLE",
        ...restOfProps
    });
};
